export const environment = {
  production: false,
  name: "TEST",
  apiUrl: "https://pmo2-be-test.map-hosting.it/api/V1/",
  logLevel: 'info',
  version: '1.2.7',
  auth0: {
    domain: 'pmo2.eu.auth0.com',
    clientId: 'FsiGbVsoRa0KHPem3dfAv2pKBefkR1kA',
    audience: 'https://pmo2-be.map-hosting.it/',
    redirectUri: window.location.origin,
  },
  firebase: {
    apiKey: "AIzaSyCMbNsbtRqKmyiT7srNeigWl9G3AvX26Rk",
    authDomain: "pmo2-6f77b.firebaseapp.com",
    projectId: "pmo2-6f77b",
    storageBucket: "pmo2-6f77b.firebasestorage.app",
    messagingSenderId: "364896877654",
    appId: "1:364896877654:web:8b80c7c0e726b852f88ff7",
    measurementId: "G-1DV8C2EZ52"
  }
};
